<template>
  <div
    id="app"
    class="home localized-home"
    dir="ltr"
  >
    <HeadNav :selectedLanguage="locale" page="gb" :gotodownload="gotodownload" :apk="apk" />

    <div id="page" class="site container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <main id="maincontent" class="site-main">
            <section class="hero">
              <div class="hero__content">
                <div class="hero__panel">
                  <div class="hero__header">
                    <h1 class="hero__title">{{ content.heroTitle }}</h1>
                    <p class="hero__subtitle">{{ content.heroSubtitle }}</p>
                    <p class="hero__hint">{{ content.heroHint }}</p>
                  </div>
                  <form class="hero__form" @submit.prevent="handleInstagramDownload">
                    <input
                      v-model="pasteUrl"
                      class="hero__input"
                      type="text"
                      :placeholder="content.placeholder"
                      :aria-label="content.placeholder"
                    />
                    <button class="hero__button" type="submit" :disabled="isParsing">
                      <img style="width: 24px; height: 24px;" src="../assets/Download.png" alt="Download" />
                      {{ isParsing ? content.parsing : content.button }}
                    </button>
                  </form>
                  <p v-if="parseError" class="hero__error">{{ parseError }}</p>
                  <div v-if="parseResult && parseResult.media && parseResult.media.length" class="ig-result">
                    <div class="ig-result__header">
                      <strong>{{ getResultSummary(parseResult.mediaCount) }}</strong>
                      <span v-if="parseResult.username">@{{ parseResult.username }}</span>
                    </div>
                    <div class="ig-result__list">
                      <div v-for="(item, index) in parseResult.media" :key="item.url" class="ig-result__item">
                        <video
                          v-if="item.type === 'video'"
                          class="ig-result__media"
                          :src="item.url"
                          :poster="item.thumbnail"
                          controls
                          playsinline
                          preload="metadata"
                        ></video>
                        <img v-else class="ig-result__media" :src="item.url" :alt="content.imageLabel" />
                        <div class="ig-result__body">
                          <span>{{ getMediaTypeLabel(item.type) }} {{ index + 1 }}</span>
                          <a class="ig-result__download" :href="getDownloadUrl(item.url, item.type)">
                            {{ content.download }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div class="markdown-content">
              <h2>{{ content.introTitle }}</h2>
              <p>{{ content.introText }}</p>

              <h2>{{ content.chooseTitle }}</h2>
              <ul>
                <li v-for="benefit in content.benefits" :key="benefit.title">
                  <strong>{{ benefit.title }}:</strong> {{ benefit.text }}
                </li>
              </ul>

              <p v-html="content.appText"></p>

              <div class="localized-home__media">
                <img src="../assets/snapinsta.webp" alt="SnapInsta" />
                <button class="hero__button" @click="gotodownload">{{ content.button }}</button>
              </div>

              <h2>{{ content.featuresTitle }}</h2>
              <template v-for="feature in content.features">
                <h3><strong>{{ feature.title }}:</strong></h3>
                <p>{{ feature.text }}</p>
              </template>

              <h2>{{ content.howTitle }}</h2>
              <ol>
                <li v-for="step in content.steps" :key="step.title">
                  <strong>{{ step.title }}:</strong> {{ step.text }}
                </li>
              </ol>

              <h2>{{ content.faqTitle }}</h2>
              <template v-for="faq in content.faqs">
                <h3>{{ faq.question }}</h3>
                <p>{{ faq.answer }}</p>
              </template>
            </div>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import 'swiper/css/swiper.css';
import axios from 'axios';

const translations = {
  tr: {
    heroTitle: 'Instagram Video İndir',
    heroSubtitle: "Instagram video, fotoğraf, Reels ve Story'leri online indirin",
    heroHint: 'Bağlantıyı yapıştırın ve indir düğmesine dokunun',
    placeholder: 'INSTAGRAM BAĞLANTISINI YAPIŞTIRIN',
    button: 'İndir',
    download: 'İndir',
    parsing: 'İşleniyor...',
    imageLabel: 'Instagram görseli',
    videoLabel: 'Video',
    fileLabel: 'dosya',
    filesLabel: 'dosya',
    ready: 'hazır',
    emptyError: 'Lütfen önce bir Instagram bağlantısı yapıştırın.',
    invalidError: 'Geçerli bir Instagram bağlantısı girin.',
    genericError: 'Instagram içeriği işlenemedi. Bağlantıyı kontrol edip tekrar deneyin.',
    introTitle: 'SnapInsta ile Instagram video ve fotoğraflarını indirin',
    introText:
      "SnapInsta, herkese açık Instagram içeriklerini daha kolay kaydetmeniz için hazırlanmış ücretsiz bir araçtır. Instagram bağlantısını yapıştırarak uygun Reels, video, Story ve fotoğrafları birkaç adımda indirebilirsiniz. Hesap açmanız veya giriş yapmanız gerekmez.",
    chooseTitle: 'Neden SnapInsta tercih ediliyor?',
    benefits: [
      {
        title: 'Kolay kullanım',
        text: 'Bağlantıyı kopyalayın, sayfaya yapıştırın ve uygun indirme seçeneğini seçin.',
      },
      {
        title: 'Birden fazla içerik türü',
        text: 'Reels, video, Story ve fotoğraf gibi herkese açık Instagram içerikleri desteklenir.',
      },
      {
        title: 'Hızlı ve güvenli',
        text: 'İndirme işlemi tarayıcı üzerinden yapılır; Instagram şifrenizi paylaşmanız gerekmez.',
      },
      {
        title: 'Akıcı deneyim',
        text: 'Masaüstünde ve telefonda karmaşık adımlar olmadan kullanabileceğiniz sade bir yapı sunar.',
      },
    ],
    appText:
      '<a href="https://snapsinsta.com/">SnapInsta</a>, Instagram içeriklerini cihazına kaydetmek isteyen kullanıcılar için tasarlanmış kullanıcı dostu bir web aracıdır. Günlük kullanıcılar ve içerik üreticileri uygun içerikleri kolayca indirebilir.',
    featuresTitle: 'SnapInsta indiricinin öne çıkan özellikleri',
    features: [
      {
        title: 'Reels indirici',
        text: "Beğendiğiniz herkese açık Reels videolarını telefonunuza veya bilgisayarınıza kaydedin, çevrimdışı izleyin ve uygun olduğunda paylaşın.",
      },
      {
        title: 'Video indirici',
        text: "Eğitim videoları, kısa klipler veya gezi videoları için Instagram bağlantısını yapıştırmanız yeterlidir; uygun video dosyasını indirebilirsiniz.",
      },
      {
        title: 'Story ve fotoğraf indirici',
        text: "Herkese açık Story ve fotoğrafları kaydederek önemli anları daha sonra tekrar görüntülemek üzere saklayabilirsiniz.",
      },
      {
        title: 'Kullanıcı dostu arayüz',
        text: 'Sade tasarım, indirme adımlarını kısa ve anlaşılır tutar. Teknik bilginiz olmasa da aracı rahatça kullanabilirsiniz.',
      },
      {
        title: 'Hesap bilgisi istemez',
        text: 'Herkese açık bağlantıları işlemek için Instagram kullanıcı adı, şifre veya hesap bilgisi vermeniz gerekmez.',
      },
    ],
    howTitle: 'SnapInsta ile Instagram videosu nasıl indirilir?',
    steps: [
      {
        title: 'Bağlantıyı kopyalayın',
        text: 'İndirmek istediğiniz herkese açık Reels, video, Story veya fotoğrafın bağlantısını Instagram üzerinden kopyalayın.',
      },
      {
        title: 'Bağlantıyı yapıştırın',
        text: 'SnapInsta ana sayfasını açın ve kopyaladığınız Instagram bağlantısını indirme alanına yapıştırın.',
      },
      {
        title: 'İndirin',
        text: 'İndir düğmesine dokunun. Araç bağlantıyı işledikten sonra kullanılabilir dosyaları gösterir.',
      },
      {
        title: 'Dosyayı kaydedin',
        text: 'Listelenen içerikten istediğinizi indirin ve dosyayı cihazınızda uygun klasöre kaydedin.',
      },
    ],
    faqTitle: 'Instagram indirici hakkında sık sorulan sorular',
    faqs: [
      {
        question: 'Instagram videosu bağlantıdan nasıl indirilir?',
        answer: 'Herkese açık videonun bağlantısını kopyalayın, SnapInsta alanına yapıştırın ve İndir düğmesine dokunun. Uygun dosya hazır olduğunda indirme seçeneği görünür.',
      },
      {
        question: 'Özel Instagram videolarını indirebilir miyim?',
        answer: 'Hayır. SnapInsta yalnızca herkese açık içerikler için kullanılabilir. Özel hesapların içeriklerine erişmek için giriş bilgilerinizi üçüncü taraf bir araca vermeyin.',
      },
      {
        question: 'Hesap oluşturmam gerekiyor mu?',
        answer: 'Hayır. İndirme aracını kullanmak için kayıt olmanız veya giriş yapmanız gerekmez.',
      },
      {
        question: 'SnapInsta ücretsiz mi?',
        answer: 'Evet. Instagram bağlantılarını işlemek için ücret veya abonelik gerekmez.',
      },
      {
        question: 'Hangi cihazlarda çalışır?',
        answer: 'Telefon, tablet, dizüstü bilgisayar ve masaüstü bilgisayarlarda güncel bir web tarayıcısıyla kullanılabilir.',
      },
      {
        question: 'İndirdiğim içeriği nasıl kullanabilirim?',
        answer: 'İçeriği yalnızca gerekli haklara veya izne sahip olduğunuz durumlarda kullanın. Telif hakkına ve içerik sahibinin koşullarına uymak sizin sorumluluğunuzdadır.',
      },
    ],
  },
  ar: {
    heroTitle: 'تنزيل فيديو إنستغرام',
    heroSubtitle: 'نزّل فيديوهات إنستغرام والصور والريلز والستوري عبر الإنترنت',
    heroHint: 'الصق الرابط ثم اضغط زر التنزيل',
    placeholder: 'الصق رابط إنستغرام',
    button: 'تنزيل',
    download: 'تنزيل',
    parsing: 'جارٍ المعالجة...',
    imageLabel: 'صورة من إنستغرام',
    videoLabel: 'فيديو',
    fileLabel: 'ملف',
    filesLabel: 'ملفات',
    ready: 'جاهز',
    emptyError: 'يرجى لصق رابط إنستغرام أولاً.',
    invalidError: 'أدخل رابط إنستغرام صالحًا.',
    genericError: 'تعذرت معالجة محتوى إنستغرام. تحقق من الرابط وحاول مرة أخرى.',
    introTitle: 'نزّل فيديوهات وصور إنستغرام باستخدام SnapInsta',
    introText:
      'يوفر SnapInsta طريقة سهلة لحفظ المحتوى العام من إنستغرام. الصق رابط المنشور لتتمكن من تنزيل الريلز والفيديوهات والستوري والصور المتاحة خلال خطوات قليلة، من دون إنشاء حساب أو تسجيل الدخول.',
    chooseTitle: 'لماذا يختار المستخدمون SnapInsta؟',
    benefits: [
      {
        title: 'استخدام سهل',
        text: 'انسخ الرابط، والصقه في الصفحة، ثم اختر ملف التنزيل المتاح.',
      },
      {
        title: 'دعم أنواع متعددة',
        text: 'يمكن معالجة الريلز والفيديوهات والستوري والصور العامة من إنستغرام.',
      },
      {
        title: 'سريع وآمن',
        text: 'تتم العملية من خلال المتصفح، ولا نطلب منك مشاركة كلمة مرور إنستغرام.',
      },
      {
        title: 'تجربة واضحة',
        text: 'واجهة بسيطة تعمل على الهاتف والكمبيوتر من دون خطوات معقدة.',
      },
    ],
    appText:
      '<a href="https://snapsinsta.com/">SnapInsta</a> أداة ويب سهلة الاستخدام صُممت لمساعدة مستخدمي إنستغرام على تنزيل المحتوى العام. سواء كنت تستخدم إنستغرام يوميًا أو تنشئ محتوى، يمكنك حفظ الملفات المتاحة بسرعة.',
    featuresTitle: 'أبرز مزايا أداة التنزيل SnapInsta',
    features: [
      {
        title: 'تنزيل الريلز',
        text: 'احفظ مقاطع الريلز العامة التي تعجبك على هاتفك أو جهاز الكمبيوتر لمشاهدتها دون اتصال.',
      },
      {
        title: 'تنزيل الفيديو',
        text: 'الصق رابط الفيديو العام، مثل مقطع تعليمي أو مقطع قصير، ثم نزّل النسخة المتاحة.',
      },
      {
        title: 'تنزيل الستوري والصور',
        text: 'احفظ الستوري والصور العامة للرجوع إليها لاحقًا بدلًا من تصوير الشاشة.',
      },
      {
        title: 'واجهة سهلة',
        text: 'تصميم واضح يجعل خطوات التنزيل قصيرة وسهلة حتى للمستخدمين الجدد.',
      },
      {
        title: 'من دون بيانات حساب',
        text: 'لا تحتاج إلى اسم المستخدم أو كلمة المرور أو أي بيانات دخول لمعالجة الروابط العامة.',
      },
    ],
    howTitle: 'كيف تنزّل فيديو من إنستغرام باستخدام SnapInsta؟',
    steps: [
      {
        title: 'انسخ الرابط',
        text: 'افتح الريلز أو الفيديو أو الستوري أو الصورة العامة التي تريد حفظها وانسخ رابطها من إنستغرام.',
      },
      {
        title: 'الصق الرابط',
        text: 'افتح SnapInsta وضع الرابط المنسوخ في حقل التنزيل.',
      },
      {
        title: 'اضغط تنزيل',
        text: 'اضغط زر التنزيل وانتظر حتى تعرض الأداة الملفات المتاحة.',
      },
      {
        title: 'احفظ الملف',
        text: 'اختر الملف الذي تريده ونزّله إلى جهازك.',
      },
    ],
    faqTitle: 'الأسئلة الشائعة حول تنزيل فيديوهات إنستغرام',
    faqs: [
      {
        question: 'كيف أنزّل فيديو إنستغرام من الرابط؟',
        answer: 'انسخ رابط الفيديو العام، والصقه في SnapInsta، ثم اضغط تنزيل. ستظهر الملفات المتاحة بعد معالجة الرابط.',
      },
      {
        question: 'هل يمكن تنزيل فيديوهات من حسابات خاصة؟',
        answer: 'لا. الأداة مخصصة للمحتوى العام فقط. لا تشارك كلمة مرور إنستغرام مع أي أداة تنزيل خارجية.',
      },
      {
        question: 'هل أحتاج إلى إنشاء حساب؟',
        answer: 'لا. يمكنك استخدام أداة التنزيل من دون تسجيل أو تسجيل دخول.',
      },
      {
        question: 'هل SnapInsta مجاني؟',
        answer: 'نعم، معالجة روابط إنستغرام متاحة مجانًا ومن دون اشتراك.',
      },
      {
        question: 'هل يعمل على الهاتف والكمبيوتر؟',
        answer: 'نعم. يمكن استخدام الموقع من الهاتف أو الجهاز اللوحي أو الكمبيوتر عبر متصفح حديث.',
      },
      {
        question: 'ما المسموح فعله بالملف الذي أنزّله؟',
        answer: 'استخدم الملف فقط عندما تملك الحق أو الإذن اللازم، والتزم بقوانين حقوق النشر وشروط صاحب المحتوى.',
      },
    ],
  },
  hi: {
    heroTitle: 'Instagram वीडियो डाउनलोड',
    heroSubtitle: 'Instagram वीडियो, फोटो, Reels और Story ऑनलाइन डाउनलोड करें',
    heroHint: 'लिंक पेस्ट करें और डाउनलोड बटन दबाएं',
    placeholder: 'INSTAGRAM लिंक पेस्ट करें',
    button: 'डाउनलोड',
    download: 'डाउनलोड',
    parsing: 'प्रोसेस हो रहा है...',
    imageLabel: 'Instagram फोटो',
    videoLabel: 'वीडियो',
    fileLabel: 'फाइल',
    filesLabel: 'फाइलें',
    ready: 'तैयार',
    emptyError: 'पहले Instagram लिंक पेस्ट करें।',
    invalidError: 'सही Instagram लिंक दर्ज करें।',
    genericError: 'Instagram कंटेंट प्रोसेस नहीं हो सका। लिंक जांचें और फिर कोशिश करें।',
    introTitle: 'SnapInsta से Instagram वीडियो और फोटो डाउनलोड करें',
    introText:
      'SnapInsta सार्वजनिक Instagram कंटेंट को आसानी से सेव करने के लिए बनाया गया ऑनलाइन टूल है। पोस्ट का लिंक पेस्ट करके उपलब्ध Reels, वीडियो, Story और फोटो कुछ ही चरणों में डाउनलोड करें। अकाउंट बनाने या लॉगिन करने की जरूरत नहीं है।',
    chooseTitle: 'लोग SnapInsta क्यों चुनते हैं?',
    benefits: [
      {
        title: 'आसान इस्तेमाल',
        text: 'लिंक कॉपी करें, पेज पर पेस्ट करें और उपलब्ध डाउनलोड विकल्प चुनें।',
      },
      {
        title: 'कई तरह का कंटेंट',
        text: 'सार्वजनिक Reels, वीडियो, Story और फोटो प्रोसेस किए जा सकते हैं।',
      },
      {
        title: 'तेज और सुरक्षित',
        text: 'डाउनलोड आपके ब्राउजर से होता है और Instagram पासवर्ड साझा करने की जरूरत नहीं होती।',
      },
      {
        title: 'सरल अनुभव',
        text: 'मोबाइल और कंप्यूटर दोनों पर बिना जटिल स्टेप्स के इस्तेमाल करें।',
      },
    ],
    appText:
      '<a href="https://snapsinsta.com/">SnapInsta</a> Instagram यूजर्स के लिए बनाया गया आसान वेब टूल है। आम यूजर हों या कंटेंट क्रिएटर, उपलब्ध पब्लिक कंटेंट को जल्दी सेव किया जा सकता है।',
    featuresTitle: 'SnapInsta डाउनलोडर की खास सुविधाएं',
    features: [
      {
        title: 'Reels डाउनलोडर',
        text: 'पसंदीदा पब्लिक Reels को फोन या कंप्यूटर पर सेव करें और ऑफलाइन देखें।',
      },
      {
        title: 'वीडियो डाउनलोडर',
        text: 'ट्यूटोरियल, छोटी क्लिप या यात्रा वीडियो का लिंक पेस्ट करके उपलब्ध वीडियो डाउनलोड करें।',
      },
      {
        title: 'Story और फोटो डाउनलोडर',
        text: 'सार्वजनिक Story और फोटो को स्क्रीनशॉट की जगह सीधे सेव करें।',
      },
      {
        title: 'आसान इंटरफेस',
        text: 'साफ डिजाइन और छोटे स्टेप्स की वजह से नए यूजर भी टूल आसानी से चला सकते हैं।',
      },
      {
        title: 'अकाउंट डेटा नहीं चाहिए',
        text: 'पब्लिक लिंक प्रोसेस करने के लिए Instagram यूजरनेम, पासवर्ड या लॉगिन जानकारी देने की जरूरत नहीं है।',
      },
    ],
    howTitle: 'SnapInsta से Instagram वीडियो कैसे डाउनलोड करें?',
    steps: [
      {
        title: 'लिंक कॉपी करें',
        text: 'जिस पब्लिक Reels, वीडियो, Story या फोटो को सेव करना है, उसका Instagram लिंक कॉपी करें।',
      },
      {
        title: 'लिंक पेस्ट करें',
        text: 'SnapInsta होम पेज खोलें और कॉपी किया गया लिंक डाउनलोड बॉक्स में पेस्ट करें।',
      },
      {
        title: 'डाउनलोड दबाएं',
        text: 'डाउनलोड बटन दबाएं और उपलब्ध मीडिया फाइलों के दिखने तक इंतजार करें।',
      },
      {
        title: 'फाइल सेव करें',
        text: 'जरूरत वाली फाइल चुनें और उसे अपने डिवाइस में सेव करें।',
      },
    ],
    faqTitle: 'Instagram डाउनलोडर से जुड़े सवाल',
    faqs: [
      {
        question: 'लिंक से Instagram वीडियो कैसे डाउनलोड करें?',
        answer: 'पब्लिक वीडियो का लिंक कॉपी करें, SnapInsta में पेस्ट करें और डाउनलोड बटन दबाएं। प्रोसेस पूरा होने पर उपलब्ध फाइल दिखेगी।',
      },
      {
        question: 'क्या प्राइवेट Instagram वीडियो डाउनलोड हो सकते हैं?',
        answer: 'नहीं। टूल केवल पब्लिक कंटेंट के लिए है। प्राइवेट कंटेंट के लिए किसी तीसरे टूल को अपना Instagram पासवर्ड न दें।',
      },
      {
        question: 'क्या अकाउंट बनाना जरूरी है?',
        answer: 'नहीं। डाउनलोडर इस्तेमाल करने के लिए रजिस्ट्रेशन या लॉगिन जरूरी नहीं है।',
      },
      {
        question: 'क्या SnapInsta मुफ्त है?',
        answer: 'हां, Instagram लिंक प्रोसेस करने के लिए कोई शुल्क या सब्सक्रिप्शन नहीं है।',
      },
      {
        question: 'क्या यह सभी डिवाइस पर काम करता है?',
        answer: 'हां। मोबाइल, टैबलेट, लैपटॉप और डेस्कटॉप पर आधुनिक ब्राउजर के साथ इस्तेमाल कर सकते हैं।',
      },
      {
        question: 'डाउनलोड किए गए कंटेंट का इस्तेमाल कैसे करें?',
        answer: 'सिर्फ तभी इस्तेमाल करें जब आपके पास जरूरी अधिकार या अनुमति हो। कॉपीराइट और कंटेंट ओनर की शर्तों का पालन करें।',
      },
    ],
  },
  es: {
    heroTitle: 'Descargar video de Instagram',
    heroSubtitle: 'Descarga videos, fotos, Reels y Stories de Instagram online',
    heroHint: 'Pega el enlace y pulsa el botón de descarga',
    placeholder: 'PEGA EL ENLACE DE INSTAGRAM',
    button: 'Descargar',
    download: 'Descargar',
    parsing: 'Procesando...',
    imageLabel: 'Imagen de Instagram',
    videoLabel: 'Video',
    fileLabel: 'archivo',
    filesLabel: 'archivos',
    ready: 'listos',
    emptyError: 'Primero pega un enlace de Instagram.',
    invalidError: 'Introduce un enlace de Instagram válido.',
    genericError: 'No se pudo procesar el contenido de Instagram. Revisa el enlace e inténtalo de nuevo.',
    introTitle: 'Descarga videos y fotos de Instagram con SnapInsta',
    introText:
      'SnapInsta es una herramienta online creada para guardar con facilidad contenido público de Instagram. Pega el enlace de una publicación para descargar los Reels, videos, Stories y fotos disponibles en pocos pasos. No necesitas crear una cuenta ni iniciar sesión.',
    chooseTitle: '¿Por qué elegir SnapInsta?',
    benefits: [
      {
        title: 'Uso sencillo',
        text: 'Copia el enlace, pégalo en la página y elige la opción de descarga disponible.',
      },
      {
        title: 'Varios tipos de contenido',
        text: 'Permite procesar Reels, videos, Stories y fotos públicas de Instagram.',
      },
      {
        title: 'Rápido y seguro',
        text: 'La descarga se realiza desde el navegador y no necesitas compartir tu contraseña de Instagram.',
      },
      {
        title: 'Experiencia fluida',
        text: 'Funciona en móvil y ordenador con pasos claros y sin complicaciones.',
      },
    ],
    appText:
      '<a href="https://snapsinsta.com/">SnapInsta</a> es una herramienta web fácil de usar para quienes desean guardar contenido público de Instagram. Tanto usuarios habituales como creadores pueden descargar los archivos disponibles rápidamente.',
    featuresTitle: 'Funciones destacadas del descargador SnapInsta',
    features: [
      {
        title: 'Descargador de Reels',
        text: 'Guarda en tu teléfono u ordenador los Reels públicos que te gustan para verlos sin conexión.',
      },
      {
        title: 'Descargador de videos',
        text: 'Pega el enlace de un tutorial, un clip corto o un video de viaje y descarga la versión disponible.',
      },
      {
        title: 'Descargador de Stories y fotos',
        text: 'Guarda Stories y fotos públicas directamente en lugar de hacer capturas de pantalla.',
      },
      {
        title: 'Interfaz fácil de usar',
        text: 'El diseño claro y los pocos pasos hacen que la herramienta sea sencilla incluso para usuarios nuevos.',
      },
      {
        title: 'Sin datos de la cuenta',
        text: 'No necesitas proporcionar usuario, contraseña ni credenciales de Instagram para procesar enlaces públicos.',
      },
    ],
    howTitle: 'Cómo descargar un video de Instagram con SnapInsta',
    steps: [
      {
        title: 'Copia el enlace',
        text: 'Abre el Reel, video, Story o foto pública que quieras guardar y copia su enlace desde Instagram.',
      },
      {
        title: 'Pega el enlace',
        text: 'Abre SnapInsta y pega el enlace copiado en el cuadro de descarga.',
      },
      {
        title: 'Pulsa Descargar',
        text: 'Pulsa el botón de descarga y espera a que la herramienta muestre los archivos disponibles.',
      },
      {
        title: 'Guarda el archivo',
        text: 'Elige el contenido que necesitas y guárdalo en tu dispositivo.',
      },
    ],
    faqTitle: 'Preguntas frecuentes sobre el descargador de Instagram',
    faqs: [
      {
        question: '¿Cómo descargar un video de Instagram desde el enlace?',
        answer: 'Copia el enlace de un video público, pégalo en SnapInsta y pulsa Descargar. Cuando termine el proceso, aparecerá el archivo disponible.',
      },
      {
        question: '¿Puedo descargar videos de cuentas privadas?',
        answer: 'No. SnapInsta está pensado para contenido público. No compartas tu contraseña de Instagram con herramientas externas.',
      },
      {
        question: '¿Necesito crear una cuenta?',
        answer: 'No. Puedes usar el descargador sin registrarte ni iniciar sesión.',
      },
      {
        question: '¿SnapInsta es gratis?',
        answer: 'Sí. Procesar enlaces de Instagram no tiene coste ni requiere suscripción.',
      },
      {
        question: '¿Funciona en todos los dispositivos?',
        answer: 'Sí. Puedes usarlo en móvil, tablet, portátil o ordenador con un navegador actualizado.',
      },
      {
        question: '¿Cómo puedo usar el contenido descargado?',
        answer: 'Úsalo solo cuando tengas los derechos o el permiso necesario y respeta los derechos de autor y las condiciones del propietario.',
      },
    ],
  },
  fr: {
    heroTitle: 'Télécharger une vidéo Instagram',
    heroSubtitle: "Téléchargez en ligne des vidéos, photos, Reels et Stories Instagram",
    heroHint: 'Collez le lien puis appuyez sur le bouton de téléchargement',
    placeholder: 'COLLEZ LE LIEN INSTAGRAM',
    button: 'Télécharger',
    download: 'Télécharger',
    parsing: 'Traitement...',
    imageLabel: 'Image Instagram',
    videoLabel: 'Vidéo',
    fileLabel: 'fichier',
    filesLabel: 'fichiers',
    ready: 'prêts',
    emptyError: "Collez d'abord un lien Instagram.",
    invalidError: 'Saisissez un lien Instagram valide.',
    genericError: "Impossible de traiter le contenu Instagram. Vérifiez le lien et réessayez.",
    introTitle: 'Téléchargez des vidéos et photos Instagram avec SnapInsta',
    introText:
      "SnapInsta est un outil en ligne conçu pour enregistrer facilement du contenu Instagram public. Collez le lien d'une publication pour télécharger les Reels, vidéos, Stories et photos disponibles en quelques étapes. Aucun compte ni connexion n'est nécessaire.",
    chooseTitle: 'Pourquoi choisir SnapInsta ?',
    benefits: [
      {
        title: 'Utilisation simple',
        text: 'Copiez le lien, collez-le dans la page puis choisissez le fichier disponible.',
      },
      {
        title: 'Plusieurs types de contenu',
        text: 'Les Reels, vidéos, Stories et photos Instagram publics peuvent être traités.',
      },
      {
        title: 'Rapide et sûr',
        text: "Le téléchargement se fait dans votre navigateur, sans partager votre mot de passe Instagram.",
      },
      {
        title: 'Expérience fluide',
        text: 'Une interface claire qui fonctionne sur mobile comme sur ordinateur, sans étapes compliquées.',
      },
    ],
    appText:
      "<a href=\"https://snapsinsta.com/\">SnapInsta</a> est un outil web facile à utiliser pour les personnes qui souhaitent conserver du contenu Instagram public. Les utilisateurs comme les créateurs peuvent télécharger rapidement les fichiers disponibles.",
    featuresTitle: 'Fonctionnalités du téléchargeur SnapInsta',
    features: [
      {
        title: 'Téléchargeur de Reels',
        text: 'Enregistrez sur votre téléphone ou votre ordinateur les Reels publics que vous aimez regarder hors ligne.',
      },
      {
        title: 'Téléchargeur de vidéos',
        text: "Collez le lien d'un tutoriel, d'un clip ou d'une vidéo de voyage puis téléchargez la version disponible.",
      },
      {
        title: 'Téléchargeur de Stories et photos',
        text: 'Enregistrez directement les Stories et photos publiques plutôt que de faire une capture d’écran.',
      },
      {
        title: 'Interface intuitive',
        text: 'Une présentation claire et quelques étapes suffisent, même pour une première utilisation.',
      },
      {
        title: 'Aucune donnée de compte',
        text: "Vous n'avez pas besoin de fournir votre identifiant, votre mot de passe ou vos accès Instagram pour traiter un lien public.",
      },
    ],
    howTitle: 'Comment télécharger une vidéo Instagram avec SnapInsta ?',
    steps: [
      {
        title: 'Copiez le lien',
        text: 'Ouvrez le Reel, la vidéo, la Story ou la photo publique à enregistrer puis copiez son lien depuis Instagram.',
      },
      {
        title: 'Collez le lien',
        text: 'Ouvrez SnapInsta et collez le lien copié dans le champ de téléchargement.',
      },
      {
        title: 'Lancez le téléchargement',
        text: "Appuyez sur le bouton de téléchargement et attendez l'affichage des fichiers disponibles.",
      },
      {
        title: 'Enregistrez le fichier',
        text: 'Choisissez le contenu souhaité et enregistrez-le sur votre appareil.',
      },
    ],
    faqTitle: 'Questions fréquentes sur le téléchargeur Instagram',
    faqs: [
      {
        question: "Comment télécharger une vidéo Instagram depuis un lien ?",
        answer: "Copiez le lien d'une vidéo publique, collez-le dans SnapInsta puis appuyez sur Télécharger. Le fichier disponible apparaîtra une fois le traitement terminé.",
      },
      {
        question: 'Puis-je télécharger des vidéos de comptes privés ?',
        answer: "Non. SnapInsta est destiné au contenu public. Ne transmettez jamais votre mot de passe Instagram à un outil tiers.",
      },
      {
        question: 'Faut-il créer un compte ?',
        answer: "Non. Le téléchargeur s'utilise sans inscription ni connexion.",
      },
      {
        question: 'SnapInsta est-il gratuit ?',
        answer: "Oui. Le traitement des liens Instagram est gratuit et ne nécessite aucun abonnement.",
      },
      {
        question: 'Fonctionne-t-il sur tous les appareils ?',
        answer: "Oui. Il fonctionne sur mobile, tablette, ordinateur portable et ordinateur de bureau avec un navigateur récent.",
      },
      {
        question: 'Comment utiliser le contenu téléchargé ?',
        answer: "Utilisez-le uniquement si vous disposez des droits ou de l'autorisation nécessaire et respectez le droit d'auteur ainsi que les conditions du propriétaire.",
      },
    ],
  },
};

export default {
  name: 'LocalizedHome',
  components: {
    HeadNav,
  },
  props: {
    locale: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pasteUrl: '',
      isParsing: false,
      parseResult: null,
      parseError: '',
      apk: null,
    };
  },
  computed: {
    content() {
      return translations[this.locale] || translations.en;
    },
  },
  methods: {
    getResultSummary(count) {
      const unit = count > 1 ? this.content.filesLabel : this.content.fileLabel;
      return `${count} ${unit} ${this.content.ready}`;
    },
    getMediaTypeLabel(type) {
      return type === 'video' ? this.content.videoLabel : this.content.imageLabel;
    },
    getDownloadUrl(url, type) {
      return `/api/instagram/download?url=${encodeURIComponent(url)}&type=${encodeURIComponent(type)}`;
    },
    gotodownload() {
      const hero = this.$el.querySelector('.hero');
      if (hero) {
        hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    async handleInstagramDownload() {
      const url = (this.pasteUrl || '').trim();
      if (!url) {
        this.parseError = this.content.emptyError;
        return;
      }
      if (!url.includes('instagram.com')) {
        this.parseError = this.content.invalidError;
        return;
      }

      this.isParsing = true;
      this.parseError = '';
      this.parseResult = null;

      try {
        const response = await axios.post(
          '/api/instagram/parse',
          { url },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        this.parseResult = response.data;
      } catch (error) {
        this.parseError =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          this.content.genericError;
      } finally {
        this.isParsing = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.localized-home {
  min-height: 100vh;
}

.hero {
  width: 100%;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 16px 120px;
  background: linear-gradient(135deg, #2e2bf3 0%, #ff38c9 100%);
}

.hero__content {
  width: 100%;
  max-width: 1100px;
  display: flex;
  justify-content: center;
}

.hero__panel {
  width: 100%;
  max-width: 950px;
  padding: 32px 40px 44px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.4) 100%);
  text-align: center;
}

.hero__title {
  margin: 0;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
}

.hero__subtitle {
  margin: 12px 0 8px;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.hero__hint {
  margin: 0;
  color: #fff;
  font-size: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.hero__form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.hero__input {
  width: 100%;
  max-width: 880px;
  height: 48px;
  padding: 0 16px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.08);
  color: #333;
  font-size: 14px;
}

.hero__input::placeholder {
  color: #777;
}

.hero__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 240px;
  height: 52px;
  padding: 0 36px;
  border: none;
  border-radius: 26px;
  background: linear-gradient(135deg, #0088ff 0%, #0067e0 100%);
  box-shadow: 0 12px 28px rgba(232, 236, 241, 0.35);
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.hero__button:hover {
  transform: translateY(-1px);
  box-shadow: 0 16px 30px rgba(190, 213, 240, 0.4);
}

.hero__button:disabled {
  cursor: not-allowed;
  opacity: 0.72;
}

.hero__error {
  max-width: 880px;
  margin: 18px auto 0;
  padding: 10px 14px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.9);
  color: #d92662;
  font-size: 14px;
  font-weight: 600;
}

.ig-result {
  max-width: 880px;
  margin: 22px auto 0;
  text-align: left;
}

.ig-result__header {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  color: #fff;
  font-size: 14px;
}

.ig-result__list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 14px;
}

.ig-result__item {
  overflow: hidden;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.14);
}

.ig-result__media {
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  background: #101010;
}

.ig-result__body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  color: #333;
  font-size: 14px;
  font-weight: 600;
}

.ig-result__download {
  flex: 0 0 auto;
  padding: 8px 14px;
  border-radius: 999px;
  background: #0067e0;
  color: #fff;
  font-size: 13px;
  text-decoration: none;
}

.markdown-content {
  max-width: 1000px;
  margin: 0 auto;
  padding: 48px 40px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  color: #4a5568;
  font-size: 16px;
  line-height: 1.75;
}

.markdown-content h2 {
  margin: 48px 0 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e2e8f0;
  color: #186dff;
  font-size: 1.75em;
  font-weight: 600;
  line-height: 1.4;
}

.markdown-content h3 {
  margin: 36px 0 16px;
  color: #186dff;
  font-size: 1.375em;
  font-weight: 600;
  line-height: 1.4;
}

.markdown-content p {
  margin: 0 0 20px;
  color: #4a5568;
  line-height: 1.75;
}

.markdown-content ul,
.markdown-content ol {
  margin: 20px 0;
  padding-left: 28px;
  color: #4a5568;
}

.markdown-content li {
  margin: 10px 0;
  line-height: 1.75;
}

.markdown-content a {
  color: #3182ce;
  font-weight: 500;
  text-decoration: none;
}

.markdown-content a:hover {
  color: #2c5aa0;
  text-decoration: underline;
}

.localized-home__media {
  position: relative;
  margin: 32px 0;
}

.localized-home__media img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.localized-home__media .hero__button {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 10;
  transform: translate(-50%, -50%);
}

.localized-home__media .hero__button:hover {
  transform: translate(-50%, -50%);
}

@media (max-width: 768px) {
  .hero {
    padding: 60px 16px 80px;
  }

  .hero__panel {
    padding: 28px 24px 38px;
  }

  .hero__title {
    font-size: 24px;
  }

  .hero__subtitle {
    font-size: 15px;
  }

  .ig-result__header,
  .ig-result__body {
    align-items: flex-start;
    flex-direction: column;
  }

  .ig-result__download {
    width: 100%;
    text-align: center;
  }

  .markdown-content {
    padding: 32px 24px;
    font-size: 15px;
  }

  .markdown-content h2 {
    margin-top: 36px;
    font-size: 1.5em;
  }

  .markdown-content h3 {
    margin-top: 28px;
    font-size: 1.25em;
  }
}
</style>
